import { AuthenticatedTemplate } from '@azure/msal-react';
import { Container } from 'react-bootstrap';
import GraphQuery from '../../components/user/graph-query';

export const UserGraph = () => {

    return (
        <>
            <AuthenticatedTemplate>
                <Container>
                    <GraphQuery />
                </Container>
            </AuthenticatedTemplate>
        </>
    );
};